import { ReactNode } from 'react';

import { cn } from '@/lib/utils/tailwind';

type SheetBodyProps = {
  children: ReactNode;
  className?: string;
};

const SheetBody = ({ children, className, ...props }: SheetBodyProps) => (
  <div className={cn(['p-4'], className)} {...props}>
    {children}
  </div>
);

export { SheetBody, type SheetBodyProps };
